<template>
  <div class="panel-container">
    <IntegrationConfigCard
      v-bind="$props"
    />
    <HubSpotForm
      class="icims-panel"
      form-id="180aedb2-9ced-4e7c-a7f3-e81fdd5d1ea8"
    />
  </div>
</template>

<script>
import IntegrationConfigCard from '@/components/settings/integrations/IntegrationConfigCard.vue';
import HubSpotForm from '@/components/settings/integrations/HubSpotForm.vue';

export default {
  name: 'IcimsSettings',
  components: {
    IntegrationConfigCard,
    HubSpotForm,
  },
  props: {
    atsName: { type: String, default: '' },
    guidance: { type: String, default: '' },
    logoUrl: { type: String, default: '' },
  },
};
</script>

  <style scoped lang="less">
    .icims-panel {
      width: calc(50% - 6px);
    }
  </style>
